import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import {
  Button,
  Card,
  CardContent,
  CardMedia,
  Chip,
  Container,
  Grid,
  Typography,
} from "@material-ui/core"
import { Link, graphql } from "gatsby"
import { useTranslation } from "react-i18next"

import TitrePage from "../components/titrePage"
import PortableText from "../components/portableText"

export const query = graphql`
  query blogQuery {
    posts: allSanityPost(
      filter: { publishedAt: { ne: "null" } }
      sort: { fields: publishedAt, order: DESC }
    ) {
      nodes {
        langue
        excerpt {
          _key
          _type
          children {
            _key
            _type
            marks
            text
          }
          list
          style
        }
        id
        title
        publishedAt
        categories {
          id
          title
        }
        slug {
          current
        }
        mainImage {
          asset {
            fixed(height: 400, width: 600) {
              src
            }
          }
        }
      }
      totalCount
    }
  }
`

export default function Blog({ data }) {
  const classes = useStyles()
  const { i18n } = useTranslation()
  const posts = data.posts.nodes

  return (
    <section className={classes.section}>
      <TitrePage titre="menu.blog" />
      <Container>
        {posts.map(post => {
          if (post.langue !== i18n.language) return null
          return <Post post={post} key={post.id} />
        })}
      </Container>
    </section>
  )
}

const Post = ({ post }) => {
  const { t } = useTranslation()
  const classes = useStyleCard()

  return (
    <Card className={classes.root}>
      <Grid container spacing={0} direction="row">
        <Grid item sm={6}>
          <CardMedia
            className={classes.cover}
            image={post.mainImage.asset.fixed.src}
            title={post.title}
          />
        </Grid>
        <Grid item sm={6} className={classes.details}>
          <CardContent className={classes.content}>
            <span className={classes.date}>
              {new Intl.DateTimeFormat("fr").format(new Date(post.publishedAt))}
            </span>
            {post.categories.map(category => (
              <Chip
                label={category.title}
                color="secondary"
                key={category.id}
                size="small"
                style={{ marginRight: "1rem" }}
              />
            ))}
            <Typography component="h3" variant="h3" color="primary">
              {post.title}
            </Typography>
            <PortableText blocks={post.excerpt} />
          </CardContent>
          <div className={classes.controls}>
            <Button color="primary">
              <Link to={`/post/${post.slug.current}`} className={classes.link}>
                {t("blog.bouton")}
              </Link>
            </Button>
          </div>
        </Grid>
      </Grid>
    </Card>
  )
}

const useStyles = makeStyles(theme => ({
  section1: {
    flexGrow: 1,
    backgroundColor: theme.palette.bgwhite,
    color: "white",
    margin: "0px auto",
  },
}))

const useStyleCard = makeStyles(theme => ({
  root: { display: "flex", marginTop: "2rem" },
  details: {
    margin: "80px 0",
    padding: "40px 60px",
  },
  content: {
    flex: "1 0 auto",
  },
  cover: {
    width: "100%",
    height: "100%",
  },
  controls: {
    display: "flex",
    alignItems: "center",
    paddingLeft: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  link: {
    textDecoration: "none",
    color: theme.palette.primary.main,
    "&:visited": { color: theme.palette.primary.main },
  },
  date: {
    color: theme.palette.lightgrey,
    fontSize: "80%",
    fontWeight: 400,
    marginRight: "1rem",
  },
}))
